import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import { useSideTitles } from '$contexts/side-titles.jsx';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

const FixedTitle = () => {
    // hooks
    const context = useSideTitles();

    if (!context?.title) {
        return null;
    }

    // render
    return (
        <div className='fixed top-0 left-0 right-0 pointer-events-none side-bar md-mt8 pt16 sm-pt16 md-pt2'>
            <div className='side-bar__aside side-bar__aside--empty' />

            <div className='side-bar__content'>
                <div className='container'>
                    <div className='relative mln9 md-m0'>
                        <div className='absolute top-0 md-relative md-col-2 px3 sm-px0 md-px0'>
                            <p className='m0 type-style-5 side-title--fixed nowrap'>{context?.title}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const StaticTitle = ({ title }) => {
    // references
    const ref = useRef();

    // state
    const [key, setKey] = useState(null);

    // hooks
    const context = useSideTitles();

    useEffect(() => {
        setKey(context.addStaticTitle(title, ref));

        return context.removeStaticTitle(key);
    }, []);

    // render
    return (
        <span
            className={key === context.current ? 'invisible' : ''}
            ref={ref}>
            {title}
        </span>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

FixedTitle.propTypes = {};

StaticTitle.propTypes = {
    title: PropTypes.string.isRequired
};

export {
    FixedTitle,
    StaticTitle
};
